import groq from "groq";
import { applyFrench } from "@lib/applyFrenchField";

export const modalSettings = groq`
    *[_id == 'modal-settings'] | order(_updatedAt desc) {
        ...,
        "title": ${applyFrench("title", "title_fr")},
        "descriptionCopy": ${applyFrench("descriptionCopy", "descriptionCopy_fr")},
        "thankYouCopy": ${applyFrench("thankYouCopy", "thankYouCopy_fr")},
        "disclaimerCopy": ${applyFrench("disclaimerCopy", "disclaimerCopy_fr")},
    }[0]
`;
